import {
  endOfISOWeek,
  format,
  getISOWeek,
  getISOWeekYear,
  parseISO,
  startOfISOWeek,
} from 'date-fns';

export const ISO_WEEK_RE = /^\d{4}-W(0[1-9]|[1-4]\d|5[0-3])$/;

export function isoWeekToRange(isoWeek: string): { start: Date; end: Date } {
  const [yearStr, weekStr] = isoWeek.split('-W');
  const year = Number(yearStr);
  const week = Number(weekStr);
  // Pick a day inside the requested ISO week. Jan 4 is always in ISO week 1
  // of its year, so offsetting by (week-1) full weeks and snapping to the
  // ISO-week boundary yields the correct range — also for year-boundary weeks.
  const jan4 = new Date(Date.UTC(year, 0, 4));
  const dayInWeek = new Date(jan4.getTime() + (week - 1) * 7 * 86400_000);
  return {
    start: startOfISOWeek(dayInWeek),
    end: endOfISOWeek(dayInWeek),
  };
}

export function dateToIsoWeek(date: Date): string {
  const year = getISOWeekYear(date);
  const week = getISOWeek(date);
  return `${year}-W${String(week).padStart(2, '0')}`;
}

/**
 * Format a desired-delivery value for display.
 * Returns "—" when neither field is set.
 */
export function formatDeliveryRequest(
  date: string | null | undefined,
  week: string | null | undefined,
): string {
  if (date) return format(parseISO(date), 'dd.MM.yyyy');
  if (week && ISO_WEEK_RE.test(week)) {
    const { start, end } = isoWeekToRange(week);
    const [yearStr, weekStr] = week.split('-W');
    return `KW ${weekStr}/${yearStr} (${format(start, 'dd.MM.')}–${format(end, 'dd.MM.')})`;
  }
  return '—';
}
